import { Injectable } from '@angular/core';
import { HttpServices } from 'src/app/shared/services/http-service.service';



@Injectable({ providedIn: 'root' })
export class PortalUserService {
    constructor(private http: HttpServices) { }

    GetPortalUser(userId: string) {
        return this.http.get('Account/FindPortalUser?UserId='+userId);
    }
   
}
